// extracted by mini-css-extract-plugin
export default {"wrapper":"Coupone_wrapper__d6CEv","form":"Coupone_form__597YU","formControl":"Coupone_formControl__aqahM","couponInfo":"Coupone_couponInfo__bgHII"};